import { observer } from 'mobx-react';
import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';

import { FilterModel } from './filter-types';

import { CheckboxGroup } from './checkbox-group';
import { FormFieldBinding } from './form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form';

@FormFieldBinding
@observer
export class PopularFilter extends React.Component<SearchFormFieldProps> {
  constructor(props) {
    super(props);
    this.isChecked = this.isChecked.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  public handleChange(evt) {
    const target = evt.target;
    const { value, filterCategory } = target;

    const { model, sortAndFilterOptions, updateModel } = this.props;

    const checkbox: FilterModel = sortAndFilterOptions && sortAndFilterOptions[filterCategory];
    const checkboxName: string = checkbox && checkbox.name;
    const modelValue = model && model[filterCategory];

    if (typeof updateModel !== 'function' || (!modelValue && modelValue !== '')) {
      return;
    }

    /* add/remove checked/unchecked values from the array */
    let newArrayValue = modelValue.slice();
    const index = newArrayValue.indexOf(value);
    if (index === -1) {
      Array.isArray(newArrayValue) ? newArrayValue.push(value) : (newArrayValue = value);
    } else {
      newArrayValue = Array.isArray(newArrayValue) ? newArrayValue.filter(item => item !== value) : '';
    }

    if ((filterCategory === 'regionId' || filterCategory === 'poi') && !newArrayValue) {
      newArrayValue =
        sortAndFilterOptions[filterCategory] && sortAndFilterOptions[filterCategory].options
          ? sortAndFilterOptions[filterCategory].options[0].value
          : '';
    }

    updateModel({
      target: {
        name: checkboxName,
        value: newArrayValue
      }
    });
  }

  private getFilterCategory(option) {
    return option.filterCategory;
  }

  private isChecked(option) {
    const { model } = this.props;

    return ((model && model[option.filterCategory]) || []).includes(option.value);
  }

  public render() {
    return (
      <AbacusExperiment name="PWA_SRP_QUICK_FILTERS">
        <AbacusControl>
          <CheckboxGroup
            getFilterCategory={this.getFilterCategory}
            isChecked={this.isChecked}
            handleChange={this.handleChange}
            {...this.props}
          />
        </AbacusControl>
        <AbacusVariant bucket={1} />
      </AbacusExperiment>
    );
  }
}
